import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Alert = {
  message: string | null;
  severity: 'success' | 'warning';
};

export type AlertState = {
  bannerAlert: Alert | null;
};

const initialState: AlertState = {
  bannerAlert: null,
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    showBannerAlert: (state, { payload: alert }: PayloadAction<Alert>) => ({
      ...state,
      bannerAlert: alert,
    }),
    dismissBannerAlert: () => initialState,
  },
});

const alertReducer = alertSlice.reducer;
const { showBannerAlert, dismissBannerAlert } = alertSlice.actions;

export { alertReducer, showBannerAlert, dismissBannerAlert };
